import { FunctionalComponent, h } from 'preact';
import { route, Route, Router, RouterOnChangeArgs } from 'preact-router';
import { useState } from 'preact/hooks';

import Breadcrumbs from './components/breadcrumbs';
import Redirect from './components/redirect';
import { config } from './config';

import { IRoutingConfig } from './interfaces/routing';
import Casinos from './routes/casinos';
import Documentation from './routes/documentation';
import Examples from './routes/examples';
import Games from './routes/games';
import Home from './routes/home';
import Login from './routes/login';
import Providers from './routes/providers';
import RealGameStats from './routes/real-game-stats';
import { isAuthenticated } from './utils/auth';

const App: FunctionalComponent = () => {
    const [currentUrl, setCurrentUrl] = useState(window.location.pathname);
    const routingConfig: IRoutingConfig = {
        '/login': {
            component: Login,
            breadcrumb: 'Login',
        },
        '/': {
            component: Home,
            breadcrumb: 'Slot Tracker Widgets',
        },
        '/documentation': {
            parent: '/',
            component: Documentation,
            breadcrumb: 'Documentation',
        },
        '/real-game-stats': {
            parent: '/',
            component: RealGameStats,
            breadcrumb: 'Real Game Stats',
        },
        '/examples': {
            parent: '/',
            component: Examples,
            breadcrumb: 'Examples',
        },
        '/games': {
            parent: '/',
            component: Games,
            breadcrumb: 'Games',
        },
        '/providers': {
            parent: '/',
            component: Providers,
            breadcrumb: 'Providers',
        },
        '/casinos': {
            parent: '/',
            component: Casinos,
            breadcrumb: 'Casinos',
        },
    };
    const onRouteChange = (e: RouterOnChangeArgs): void => {
        setCurrentUrl(e.url);

        const isUserAuthenticated = isAuthenticated();
        const loginRoute = '/login';

        if (!isUserAuthenticated && e.url !== loginRoute) {
            route('/login');
        } else if (isUserAuthenticated && e.url === '/login') {
            route('/');
        }
    };

    return (
        <div className="app">
            <div className="logo">
                <a href={config.websiteUrl}>
                    <img src="/assets/images/logo.svg" alt="" />
                </a>
            </div>

            <div className="container">
                <Breadcrumbs routingConfig={routingConfig} currentUrl={currentUrl} />
            </div>

            <div className="container page-wrap">
                <Router onChange={e => {
                    onRouteChange(e);
                }}>
                    { Object.entries(routingConfig).map(([path, options]) =>
                        <Route path={path} key={path} component={options.component} />)}
                    <Redirect to="/" default />
                </Router>
            </div>
        </div>
    );
};

export default App;
